import React from "react";
import { Button, ButtonGroup } from "@material-ui/core";
import { Flex, Image } from "@chakra-ui/react";
import { useClassroomLayoutStore } from "@/stores/v2/classroomLayoutStore";
import tileSizeSmallIcon from "@/assets/TileSizeIcons/IconTileSizeSmall.svg?url";
import tileSizeMedIcon from "@/assets/TileSizeIcons/IconTileSizeMed.svg?url";
import tileSizeLargeIcon from "@/assets/TileSizeIcons/IconTileSizeLarge.svg?url";

interface Props {
	setTabItemLimit: (limit: number) => void;
}

export function FlexibleGrid(props: Props): JSX.Element {
	const [tileSize, setTileSize] = useClassroomLayoutStore((state) => [state.tileSize, state.setTileSize]);

	return (
		<Flex className="Grid_slider">
			<ButtonGroup variant="outlined" size="small" aria-label="small button group">
				<Button
					color={tileSize === "sm" ? "secondary" : "primary"}
					onClick={() => {
						props.setTabItemLimit(3);
						setTileSize("sm");
					}}
				>
					<Image src={tileSizeSmallIcon} />
				</Button>
				<Button
					color={tileSize === "md" ? "secondary" : "primary"}
					onClick={() => {
						props.setTabItemLimit(5);
						setTileSize("md");
					}}
				>
					<Image src={tileSizeMedIcon} />
				</Button>
				<Button
					color={tileSize === "lg" ? "secondary" : "primary"}
					onClick={() => {
						props.setTabItemLimit(7);
						setTileSize("lg");
					}}
				>
					<Image src={tileSizeLargeIcon} />
				</Button>
			</ButtonGroup>
		</Flex>
	);
}
